<template>
  <div class="head">
    <div class="left_logo">
      <i class="el-icon-s-fold"></i>
      <span>仓库管理系统</span>
    </div>
    <el-popover placement="bottom" popper-class="exit_wrap" width="200" trigger="hover">
      <div class="exit_box">
        <div class="exit">
          <img src="../../src/assets/doghead.png" alt />
          <span>admin</span>
        </div>
        <div class="exit_button" @click="exitOut">退出登录</div>
      </div>
      <div class="logo_box" slot="reference">
        <div class="head_logo"></div>
        <i :class="['el-icon-caret-bottom']"></i>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "Head",
  components: {},
  data() {
    return {
      visible: false
    };
  },
  methods: {
    exitOut() {
      this.$router.push({ path: "/" });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
  background: linear-gradient(90deg, #606c88, #3f4c6b);
  margin-bottom: 2px;
  .left_logo {
    margin-left: 20px;
    cursor: pointer;
    font-size: 21px;
    color: #ffffff;
    font-weight: bold;
    .el-icon-s-fold {
      &::before {
        color: #ffffff;
        font-size: 20px;
      }
    }
  }
  .logo_box {
    display: flex;
    align-items: center;
    cursor: pointer;
    .head_logo {
      width: 24px;
      height: 24px;
      background-image: url("../../src/assets/doghead.png");
      background-size: 24px;
      margin-right: 10px;
      border-radius: 50%;
    }
  }
  .el-icon-caret-bottom {
    &::before {
      color: #ffffff;
      margin-right: 20px;
    }
  }
  .name {
    margin-right: 20px;
    font-family: cursive;
    font-weight: 700;
    font-size: 24px;
  }
}
.exit_wrap {
  .exit_box {
    display: flex;
    justify-content: center;
    flex-direction: column;
    .exit {
      display: flex;
      align-items: center;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 16px;
      }
    }
    .exit_button {
      margin: 0 auto;
      margin-top: 12px;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// common/components/head.vue